import {
  GET_P2P_ADS,
  GET_P2P_ORDERS,
  GET_P2P_OVERVIEW_STATS,
  GET_P2P_TRANSACTIONS,
  GET_P2P_WALLET_STATS,
  GET_USER_P2P_ADS,
  GET_USER_P2P_ORDERS,
  GET_USER_P2P_WALLET_STATS,
  P2P_ERROR,
  P2P_LOADING,
  UPDATE_ADS_PAGE,
  UPDATE_P2P_ACTIVE_TAB,
  UPDATE_P2P_ADS_ACTIVE_TAB,
  UPDATE_P2P_ADS_SEARCH,
  UPDATE_P2P_ADS_STATUS,
  UPDATE_P2P_ORDERS_ACTIVE_TAB,
  UPDATE_P2P_ORDERS_SEARCH,
  UPDATE_P2P_ORDERS_STATUS,
  UPDATE_USER_P2P_ACTIVE_TAB,
  UPDATE_USER_P2P_ADS_ACTIVE_STATUS,
  UPDATE_USER_P2P_ORDERS_ACTIVE_STATUS,
} from "../Types/Types";

const initState = {
  loading: null,
  error: null,
  ads: null,
  orders: null,
  overviewStats: null,
  p2pWalletStats: null,
  p2pActiveTab: "all",
  p2pAdsActiveTab: "all",
  p2pOrdersActiveTab: "all",
  p2pOrdersActiveStatus: "all",
  p2pAdsActiveStatus: "all",
  p2pAdsPage: {
    active: 0,
    inactive: 0,
    all: 0,
  },
  p2pOrdersPage: {
    pending: 0,
    completed: 0,
    failed: 0,
    all: 0,
  },
  p2pAdsTotalPages: {
    active: 0,
    inactive: 0,
    all: 0,
  },
  p2pOrdersTotalPages: {
    pending: 0,
    completed: 0,
    failed: 0,
    all: 0,
  },
  userP2PActiveTab: "ads",
  userP2POrdersActiveStatus: "all",
  userP2PAdsActiveStatus: "all",
  userP2POrders: null,
  userP2PAds: null,
  userP2PWalletStats: null,
  userP2pActiveStatus: {
    ads: "all",
    orders: "all",
  },
  userP2PPage: {
    ads: {
      active: 0,
      inactive: 0,
      all: 0,
    },
    orders: {
      pending: 0,
      completed: 0,
      failed: 0,
      all: 0,
    },
  },
  userP2PTotalPages: {
    ads: {
      active: 0,
      inactive: 0,
      all: 0,
    },
    orders: {
      pending: 0,
      completed: 0,
      failed: 0,
      all: 0,
    },
  },
  p2pAdsSearch: null,
  p2pOrdersSearch: null,
  p2pTransactions: null,
};

const P2PReducer = (state = initState, action) => {
  switch (action.type) {
    case P2P_LOADING:
      return {
        ...state,
        loading: true,
      };
    case P2P_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case GET_P2P_OVERVIEW_STATS:
      return {
        ...state,
        loading: false,
        overviewStats: action.payload,
      };
    case GET_P2P_WALLET_STATS:
      return {
        ...state,
        loading: false,
        p2pWalletStats: action.payload,
      };
    case GET_P2P_ADS:
      return {
        ...state,
        loading: false,
        ads: action.payload,
      };
    case GET_P2P_ORDERS:
      return {
        ...state,
        loading: false,
        orders: action.payload,
      };
    case UPDATE_P2P_ADS_STATUS:
      return {
        ...state,
        p2pAdsActiveStatus: action.payload,
        loading: false,
      };
    case UPDATE_P2P_ORDERS_STATUS:
      return {
        ...state,
        p2pOrdersActiveStatus: action.payload,
        loading: false,
      };
    case UPDATE_ADS_PAGE:
      return {
        ...state,
        p2pAdsPage: {
          ...state.p2pAdsPage,
          [action.payload.tab]: action.payload.value,
        },
        loading: false,
      };
    case GET_USER_P2P_ADS:
      return {
        ...state,
        loading: false,
        userP2PAds: action.payload,
      };
    case GET_USER_P2P_ORDERS:
      return {
        ...state,
        loading: false,
        userP2POrders: action.payload,
      };
    case UPDATE_P2P_ACTIVE_TAB:
      return {
        ...state,
        p2pActiveTab: action.payload,
        loading: false,
      };
    case UPDATE_P2P_ADS_ACTIVE_TAB:
      return {
        ...state,
        p2pAdsActiveTab: action.payload,
        loading: false,
      };
    case UPDATE_P2P_ORDERS_ACTIVE_TAB:
      return {
        ...state,
        p2pOrdersActiveTab: action.payload,
        loading: false,
      };
    case UPDATE_USER_P2P_ACTIVE_TAB:
      return {
        ...state,
        userP2PActiveTab: action.payload,
        loading: false,
      };
    case UPDATE_USER_P2P_ORDERS_ACTIVE_STATUS:
      return {
        ...state,
        userP2POrdersActiveStatus: action.payload,
        loading: false,
      };
    case UPDATE_USER_P2P_ADS_ACTIVE_STATUS:
      return {
        ...state,
        userP2PAdsActiveStatus: action.payload,
        loading: false,
      };
    case GET_USER_P2P_WALLET_STATS:
      return {
        ...state,
        loading: false,
        userP2PWalletStats: action.payload,
      };
    case UPDATE_P2P_ADS_SEARCH:
      return {
        ...state,
        p2pAdsSearch: action.payload,
        loading: false,
      };
    case UPDATE_P2P_ORDERS_SEARCH:
      return {
        ...state,
        p2pOrdersSearch: action.payload,
        loading: false,
      };
    case GET_P2P_TRANSACTIONS:
      return {
        ...state,
        loading: false,
        p2pTransactions: action.payload,
      };
    default:
      return state;
  }
};

export default P2PReducer;
